import SetupArticle from './SetupArticle';

export default SetupArticle;
export * from './SetupArticleProps';
